import {
  REQUEST_BILLING_BY_WORKSPACE_SLUG,
  REQUEST_BILLING_BY_WORKSPACE_SLUG_ERROR,
  RECEIVE_BILLING_BY_WORKSPACE_SLUG,
  ADDING_CREDIT_CARD,
  ADD_CREDIT_CARD,
  ADD_CREDIT_CARD_ERROR,
  UPDATING_BILLING_PLAN,
  UPDATE_BILLING_PLAN_ERROR,
  UPDATED_BILLING_PLAN
 } from 'actions'

export default function billingByWorkspaceSlug (state = {}, action) {
  const { type, payload } = action

  switch (type) {

    case REQUEST_BILLING_BY_WORKSPACE_SLUG:
      return {
        ...state,
        [payload.workspaceSlug]: {
          hasRequested: false,
          isRequesting: true,
          didRequestFail: false,
          data: {}
        }
      }
    case REQUEST_BILLING_BY_WORKSPACE_SLUG_ERROR:
      return {
        ...state,
        hasRequested: true,
        [payload.workspaceSlug]: {
          hasRequested: true,
          isRequesting: false,
          didRequestFail: true,
          data: {}
        }
      }
    case RECEIVE_BILLING_BY_WORKSPACE_SLUG:
      return {
        ...state,
        hasRequested: true,
        [payload.workspaceSlug]: {
          hasRequested: true,
          isRequesting: false,
          didRequestFail: false,
          data: payload.data
        }
      }
    case ADDING_CREDIT_CARD:
      return {
        ...state,
        [payload.slug]: {
          ...state[payload.slug],
          didAddCreditCardFail: false,
          didAddCreditCardSucceed: false
        }
      }
    case ADD_CREDIT_CARD:
      return {
        ...state,
        [payload.slug]: {
          ...state[payload.slug],
          didAddCreditCardSucceed: true,
          data: {
            ...state[payload.slug].data,
            card: payload.card
          }
        }
      }
    case ADD_CREDIT_CARD_ERROR:
      return {
        ...state,
        [payload.slug]: {
          ...state[payload.slug],
          didAddCreditCardFail: true
        }
      }
    case UPDATING_BILLING_PLAN:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: true,
          didRequestFail: false
        }
      }
    case UPDATED_BILLING_PLAN:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: false,
          data: {
            ...state[payload.workspaceSlug].data,
            subscription: {
              ...state[payload.workspaceSlug].data.subscription,
              plan: payload.plan
            }
          }
        }
      }
    case UPDATE_BILLING_PLAN_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: true
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/billing.js